import React, { useState } from 'react';
import styles from './ProductThumb.module.css';

interface IProductThumb {
	url: string;
	alt?: string;
	width?: number | 'full';
	height?: number;
	ratio?: number;
	className?: string;
	hasMargin?: boolean;
	hasShadow?: boolean;
	backgroundColor?: 'grey' | 'white';
}

function ProductThumb({
	url,
	alt,
	width = 60,
	height,
	ratio = 1,
	className,
	hasMargin = true,
	hasShadow = false,
	backgroundColor = 'grey',
	...otherProps
}: IProductThumb): JSX.Element {

	const cssClass = [styles.wrapper];
	const [display, setDisplay] = useState(true);
	const finalWidth = width === 'full' ? '100%' : width;
	const finalHeight = typeof height === 'undefined' ? width : height;

	const style:React.CSSProperties = {
		width: finalWidth
	};

	if (width === 'full') {
		cssClass.push(styles.wrapperFullWidth);
	} else {
		style.height = finalHeight;
	}

	if (width === 'full') {
		style.paddingTop = ratio * 100 + '%';
	}

	if (className) {
		cssClass.push(className);
	}

	if (hasMargin) {
		cssClass.push(styles.wrapperHasMargin);
	}

	if (backgroundColor === 'white') {
		cssClass.push(styles.wrapperBgWhite);
	}

	if (hasShadow) {
		cssClass.push(styles.wrapperHasShadow);
	}
	
	return (
		<div className={cssClass.join(' ')} style={style} {...otherProps}>
			<img
				className={styles.img}
				src={url}
				alt={alt}
				width={style.width}
				height={style.height}
				style={display ? {} : {display: 'none'}}
				onError={() => setDisplay(false)}
			/>
		</div>
	);
}

export {
	ProductThumb,
};
